import { render, staticRenderFns } from "./PageEditor.vue?vue&type=template&id=1ea71a8c"
import script from "./PageEditor.vue?vue&type=script&lang=js"
export * from "./PageEditor.vue?vue&type=script&lang=js"
import style0 from "./PageEditor.vue?vue&type=style&index=0&id=1ea71a8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports